export function formatIntervalLabel(interval: string, intervalCount: number): string {
	if (interval === 'year') return `${intervalCount} ${intervalCount === 1 ? 'ano' : 'anos'}`;
	if (interval === 'month') return `${intervalCount} ${intervalCount === 1 ? 'mês' : 'meses'}`;
	return interval;
}

export function formatIntervalRateLabel(interval: string, intervalCount: number): string {
	if (intervalCount === 1) {
		if (interval === 'year') return 'ano';
		if (interval === 'month') return 'mês';
		return interval;
	}
	return formatIntervalLabel(interval, intervalCount);
}

export function formatIntervalAdjective(interval: string, intervalCount: number): string {
	if (interval === 'month') return intervalCount === 1 ? 'Mensal' : `A cada ${intervalCount} meses`;
	if (interval === 'year') return intervalCount === 1 ? 'Anual' : `A cada ${intervalCount} anos`;
	return interval;
}

export function formatPlanPriceBrl(cents: number): string {
	const value = cents / 100;
	const hasCents = !Number.isInteger(value);
	return value.toLocaleString('pt-BR', {
		minimumFractionDigits: hasCents ? 2 : 0,
		maximumFractionDigits: 2,
	});
}
